import { useState } from 'react'
import { useMe, useSignOut } from '../../lib/queries/session.js'
import { Menu } from './Menu.jsx'
import styles from './ui.module.css'

function initials(user) {
  const source = user?.name || user?.email || '?'
  const parts = source.split(/[\s@._-]+/).filter(Boolean)
  return ((parts[0]?.[0] ?? '?') + (parts[1]?.[0] ?? '')).toUpperCase()
}

/** Google profile picture, falling back to initials when missing or broken. */
export function Avatar({ user, size = 32 }) {
  const [broken, setBroken] = useState(false)
  const style = { width: size, height: size, fontSize: Math.round(size * 0.4) }
  if (user?.picture && !broken) {
    return (
      <img
        className={styles.avatar}
        style={style}
        src={user.picture}
        alt=""
        referrerPolicy="no-referrer"
        onError={() => setBroken(true)}
      />
    )
  }
  return (
    <span className={`${styles.avatar} ${styles.avatarInitials}`} style={style} aria-hidden="true">
      {initials(user)}
    </span>
  )
}

/**
 * Signed-in user's avatar and name; opens a menu with Sign out.
 * `compact` shows only the avatar (e.g. in a page header).
 */
export function UserMenu({ side = 'top', align = 'start', compact = false }) {
  const { user } = useMe()
  const signOut = useSignOut()
  const name = user?.name || user?.email?.split('@')[0] || 'Account'

  return (
    <Menu
      side={side}
      align={align}
      trigger={(props) => (
        <button
          type="button"
          className={`${styles.userButton} ${compact ? styles.userButtonCompact : ''}`}
          aria-label={`Account: ${name}`}
          title={user?.email ?? name}
          {...props}
        >
          <Avatar user={user} size={compact ? 32 : 30} />
          {compact ? null : (
            <span className={styles.userText}>
              <span className={styles.userName}>{name}</span>
              {user?.email ? <span className={styles.userEmail}>{user.email}</span> : null}
            </span>
          )}
        </button>
      )}
      items={[
        { label: 'Sign out', onSelect: () => signOut() },
        { label: 'Sign out everywhere', danger: true, onSelect: () => signOut({ everywhere: true }) },
      ]}
    />
  )
}
